import { ParserFormatter } from './core.js';

export class NumberFormatter extends ParserFormatter<number> {
  format(value: number): string {
    return `${value}`;
  }

  parse(valueStr: string): number {
    return Number(valueStr.trim());
  }

  get type(): string {
    return 'number';
  }
}

export function numberFormatter() {
  return new NumberFormatter();
}
